const Card = {
  baseStyle: {
    container: {
      position: "relative",
      borderRadius: "0.1875rem",
      width: "100%",
      transform: "scale(1) translate3d(0px, 0px, 0px)",
      transition: "border 170ms ease-in-out 0s",
      background: "rgb(255, 255, 255)",
      border: "1px solid rgb(239, 239, 239)",
      backgroundColor: "white",
      _hover: {
        border: "0.0625rem solid rgba(0, 0, 0, 0.333)",
        boxShadow: "rgba(0, 0, 0, 0.17) 0px 0.5rem 1rem -0.5rem, rgba(0, 0, 0, 0.333) 0px 0px 0.25rem -0.0625rem"
      },
      _dark: {
        borderColor: "grayscale.600",
        backgroundColor: "grayscale.850",
        _hover: {
          borderColor: "rgba(255, 255, 255, 0.333)",
          boxShadow: "rgba(0, 0, 0, 0.17) 0px 0.5rem 1rem -0.5rem, rgba(0, 0, 0, 0.333) 0px 0px 0.25rem -0.0625rem"
        }
      }
    }
  }
};

export { Card };
